var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _g, _path1, _path10, _path11, _polygon, _g2, _path12, _path13;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRetailPos(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 150,
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 70 75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        isolation: isolate;\n        opacity: .27;\n      }\n\n      .st1 {\n        fill: #010101;\n      }\n\n      .st2 {\n        fill: #fff;\n      }\n\n      .st3 {\n        fill: #a5c2e6;\n      }\n\n      .st4 {\n        fill: #fdfeff;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M36.46,21.95c-.19,0-.34-.15-.34-.34,0-2.01-1.38-4.16-3.42-4.16h-3.72c-.19,0-.34-.15-.34-.34s.15-.34.34-.34h3.72c2.45,0,4.1,2.5,4.1,4.84,0,.19-.15.34-.34.34Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M10.18,49.26c-2.51,0-4.27-1.64-4.27-3.98v-24.13c0-2.41,1.94-4.38,4.33-4.38h3.4c.19,0,.34.15.34.34s-.15.34-.34.34h-3.4c-2.01,0-3.65,1.66-3.65,3.7v24.13c0,1.95,1.48,3.3,3.59,3.3.19,0,.34.15.34.34s-.15.34-.34.34Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M14.14,49.27h-4c-.19,0-.34-.15-.34-.34s.15-.34.34-.34h4c.19,0,.34.15.34.34s-.15.34-.34.34Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M30.83,35.74h-10.67c-.19,0-.34-.15-.34-.34s.15-.34.34-.34h10.67c.19,0,.34.15.34.34s-.15.34-.34.34Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M26.85,44.84c-.19,0-.34-.15-.34-.34v-6.99c0-.19.15-.34.34-.34s.34.15.34.34v6.99c0,.19-.15.34-.34.34Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M30.79,47.67h-7.88c-.19,0-.34-.15-.34-.34s.15-.34.34-.34h7.88c.19,0,.34.15.34.34s-.15.34-.34.34Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M30.93,50.61h-5.88c-.19,0-.34-.15-.34-.34s.15-.34.34-.34h5.88c.19,0,.34.15.34.34s-.15.34-.34.34Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M22.81,47.66c-.15,0-.29-.1-.33-.26l-3.61-14.94c-.04-.18.07-.37.25-.41.18-.04.37.07.41.25l3.61,14.94c.04.18-.07.37-.25.41-.03,0-.05,0-.08,0Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M19.16,32.62h-5.03c-.19,0-.34-.15-.34-.34s.15-.34.34-.34h5.03c.19,0,.34.15.34.34s-.15.34-.34.34Z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M26.03,20.65h-9.44c-1.82,0-3.3-1.48-3.3-3.3s1.48-3.3,3.3-3.3h9.44c1.82,0,3.3,1.48,3.3,3.3s-1.48,3.3-3.3,3.3ZM16.58,14.73c-1.45,0-2.62,1.18-2.62,2.62s1.18,2.62,2.62,2.62h9.44c1.45,0,2.62-1.18,2.62-2.62s-1.18-2.62-2.62-2.62h-9.44Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M34.63,27.07h25.48c1.92,0,3.47,1.56,3.47,3.47v13.2H31.16v-13.2c0-1.92,1.56-3.47,3.47-3.47h0Z"
  }))), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M60.25,60.48h-25.48c-1.92,0-3.47-1.56-3.47-3.47v-13.27h32.42v13.27c0,1.92-1.56,3.47-3.47,3.47h0Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M34.77,27.03h25.48c1.92,0,3.47,1.56,3.47,3.47v13.23H31.3v-13.23c0-1.92,1.56-3.47,3.47-3.47h0Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M35.03,60.95c-2.39,0-4.33-1.94-4.33-4.33v-25.78c0-2.39,1.94-4.33,4.33-4.33h24.73c2.39,0,4.33,1.94,4.33,4.33v15.38c0,.19-.15.34-.34.34s-.34-.15-.34-.34v-15.38c0-2.01-1.64-3.65-3.65-3.65h-24.73c-2.01,0-3.65,1.64-3.65,3.65v25.78c0,2.01,1.64,3.65,3.65,3.65.19,0,.34.15.34.34s-.15.34-.34.34Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "51.81 27.2 51.81 36.03 47.31 33.14 42.93 36.25 42.93 27.2 51.81 27.2"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M57.07,56.3c-.19,0-.34-.15-.34-.34v-5.88c0-.19.15-.34.34-.34s.34.15.34.34v5.88c0,.19-.15.34-.34.34Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "54.3 52.33 54.8 52.79 57.07 50.34 59.35 52.79 59.84 52.33 57.07 49.35 54.3 52.33"
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M48.27,60.95h-13.35c-.19,0-.34-.15-.34-.34s.15-.34.34-.34h13.35c.19,0,.34.15.34.34s-.15.34-.34.34Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M25.15,54.55c-1.28,0-2.31-1.04-2.31-2.31s1.04-2.31,2.31-2.31,2.31,1.04,2.31,2.31-1.04,2.31-2.31,2.31ZM25.15,50.6c-.9,0-1.64.73-1.64,1.64s.73,1.64,1.64,1.64,1.64-.73,1.64-1.64-.73-1.64-1.64-1.64Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRetailPos);
export default __webpack_public_path__ + "static/media/retailPos.1d0a88ccdc5705e982ef91bd8bbf9e5c.svg";
export { ForwardRef as ReactComponent };